// Translations
import membersList from '../sections/members-list/translations/en'

// Translation: Account > Members (English)
export default Object.freeze({
	header: {
		subtitle: 'Manage team members and add new ones',
		title: 'Team members'
	},
	sections: { membersList }
})
